import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as userApis from "../../utilities/apis/user"
import * as permissionsApis from "../../utilities/apis/permissions"
import Layout from "../../components/Layout"

const User = () => {
  const navigate = useNavigate()
  const { user, token } = useSelector(state => state.user)
  const [roles, setRoles] = useState([])
  const nameRef = useRef(null)
  const usernameRef = useRef(null)
  const passwordRef = useRef(null)
  const roleRef = useRef(null)
  const params = new URLSearchParams(window.location.search)

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const name = e.target.name.value
      const username = e.target.username.value
      const password = e.target.password.value
      const role_id = e.target.role.value
      const payload = { name, username, password, role_id }

      if (!params.has("id")) {
        const response = await userApis.createUser(token, payload)
        if (!response.status) throw new Error(response.message)

        nameRef.current.value = ""
        usernameRef.current.value = ""
        passwordRef.current.value = ""
        roleRef.current.value = ""
      } else {
        payload.id = parseInt(params.get("id"))
        const response = await userApis.updateUser(token, payload)
        if (!response.status) throw new Error(response.message)
      }

      alert("User saved")
      navigate("/dashboard/users")
    } catch (error) {
      alert(error.message)
    }
  }

  const getRoles = async () => {
    try {
      const response = await permissionsApis.getRoles(token)
      if (!response.status) throw new Error(response.message)

      setRoles(response.roles)
    } catch (error) {
      alert(error.message)
    }
  }

  const getUser = async () => {
    try {
      const response = await userApis.getUser(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      nameRef.current.value = response.user.name
      usernameRef.current.value = response.user.username
      passwordRef.current.value = response.user.password
      setTimeout(() => {
        roleRef.current.value = response.user.role_id
      }, 10)

    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    getRoles()
    if (params.has("id")) getUser()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-25 mx-auto">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex gap-3 align-items-center">
                <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                <p className="lead text-body-emphasis fw-bold m-0">{params.has("id") ? "Edit" : "Add"} User</p>
              </div>

              <div className="card rounded-4 shadow-none">
                <div className="card-body py-4">
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <label htmlFor="name" className="form-label">Name</label>
                      <input ref={nameRef} type="text" className="form-control" id="name" placeholder="Name" required />
                    </div>
                    <div>
                      <label htmlFor="username" className="form-label">Username</label>
                      <input ref={usernameRef} type="text" className="form-control" id="username" placeholder="Username" required />
                    </div>
                    <div>
                      <label htmlFor="password" className="form-label">Password</label>
                      <input ref={passwordRef} type="password" className="form-control" id="password" placeholder="Password" required />
                    </div>
                    <div>
                      <label htmlFor="role" className="form-label">Role</label>
                      <select ref={roleRef} className="form-select text-capitalize" id="role" required>
                        {roles.map((role) => {
                          return (
                            <option key={role.id.toString()} value={role.id} className="text-capitalize">{role.name}</option>
                          )
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button type="submit" className="btn btn-theme rounded-4 w-25">Save</button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default User
